/**
 * 將效期與批號組成單一顯示字串，用於「效期_批號」欄位。
 * @param effectiveDate 效期，可能為 null
 * @param batchNumber 批號，可能為 null
 * @returns 兩者皆有 → `效期_批號`；只有效期 → `效期`；只有批號 → `_批號`；皆無 → `-`
 */
export default function formatEffectiveDateBatch(effectiveDate: string | null, batchNumber: string | null): string {
  if (!effectiveDate && !batchNumber) return "-";
  if (effectiveDate && batchNumber) return `${effectiveDate}_${batchNumber}`;
  if (effectiveDate) return effectiveDate;
  return `_${batchNumber}`;
}
